import React from 'react';
import cn from 'clsx';
import { type LinkType } from '@ev-tech/ui-core-components/utils';

import { type NavigationTrackingContext } from '@/types/tracking';

import styles from './Link.module.css';

export interface ILinkProps {
  className?: string;
  label: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  as?: 'a' | 'button';
  href?: string;
  disabled?: boolean;
  target?: string;
  linkType?: LinkType;
  rel?: string;
  trackingInfo?: NavigationTrackingContext;
}

export const Link = ({
  className,
  label,
  onClick,
  as,
  href,
  disabled,
  target,
  rel,
  trackingInfo,
  //! added pass-through props to support aria attributes
  ...props
}: ILinkProps) => {
  const handleLinkClick = () => {
    trackingInfo?.handleEvent?.(trackingInfo);
  };

  const linkClassName = cn(styles.link, className);

  if (as === 'button') {
    return (
      <button
        className={linkClassName}
        onClick={onClick}
        disabled={disabled}
        //! added pass-through props to support aria attributes
        {...props}
      >
        <span>{label}</span>
      </button>
    );
  }

  //! removed "external" check because what's internal for spearhead is external for us
  //! https://git.engelvoelkers.com/ev/search/frontend/-/merge_requests/1431#note_386139

  if (!href) console.error('Link Component: href is required for anchor tag');

  return (
    <a
      className={linkClassName}
      target={target}
      rel={rel}
      onClick={handleLinkClick}
      href={href}
      //! added pass-through props to support aria attributes
      {...props}
    >
      <span>{label}</span>
    </a>
  );
};
